import { Container, FederatedPointerEvent, Sprite } from "pixi.js";
import { YouNoMoreOwnerResourcePackage } from "../../resources/YouNoMoreOwnerResourcePackage";
import { CommonResourcesPackage } from "by/gamefactory/cityversetycoon/scenes/common/resources/CommonResourcesPackage";
import { TakeMeToMPButton } from "./TakeMeToMPButton";
import { Event } from "event-system";
import { YouNoMoreOwnerTextContainer } from "./YouNoMoreOwnerTextContainer";

export class YouNoMoreOwnerContainer extends Container {
    
    private readonly commonResources: CommonResourcesPackage;
    private readonly youNoMoreOwnerResources: YouNoMoreOwnerResourcePackage;

    private background: Sprite;
    private takeMeToMPButton: TakeMeToMPButton;
    private textContainer: YouNoMoreOwnerTextContainer;

    public get onTakeMeToMPButtonClick(): Event<TakeMeToMPButton, FederatedPointerEvent> {
        return this.takeMeToMPButton.onUp;
    }

    public constructor(commonResources: CommonResourcesPackage, youNoMoreOwnerResources: YouNoMoreOwnerResourcePackage) {
        super();
        this.commonResources = commonResources;
        this.youNoMoreOwnerResources = youNoMoreOwnerResources;
        this.build();
        this.layout();
    }

    private build(): void {
        this.background = new Sprite(this.youNoMoreOwnerResources.assets_views_you_no_more_owner_glass_png);
        this.takeMeToMPButton = new TakeMeToMPButton(this.commonResources);
        this.textContainer = new YouNoMoreOwnerTextContainer();

        this.addChild(
            this.background,
            this.takeMeToMPButton,
            this.textContainer
        );
    }

    private layout(): void {
        this.takeMeToMPButton.position.set(this.background.width * 0.5 - this.takeMeToMPButton.width * 0.5, 752);
        this.textContainer.position.set(79, 113);
    }
}
